import React, { createContext, useState } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
const [actorMobileNo, setActorMobileNo] = useState("");

  return (
    <UserContext.Provider value={{ actorMobileNo, setActorMobileNo }}>
      {children}
    </UserContext.Provider>
  );
};
